export const reduceDeactivateUserRequest = (state) => {
  return {
    ...state,
    ui: { ...state.ui, isDeactivatingUser: true },
  };
};

export const reduceDeactivateUserSuccess = (state, { payload: { userId } }) => {
  const { byId } = state?.base || {};
  const { byBoard } = state;

  const newByBoard = {};
  const byBoardKeys = Object.keys(byBoard);

  // remove user ids from boards
  for (let i = 0, l = byBoardKeys.length; i < l; i += 1) {
    const boardId = byBoardKeys[i];
    const teamMembersId = byBoard[boardId] || [];
    newByBoard[boardId] = teamMembersId.filter((id) => id !== userId);
  }

  const user = byId[userId];
  const userWithDisabled = { ...user, disabled: true };

  return {
    ...state,
    base: { ...state.base, byId: { ...byId, [userId]: userWithDisabled } },
    byBoard: newByBoard,
    ui: { ...state.ui, isDeactivatingUser: false },
  };
};

export const reduceDeactivateUserFailure = (state) => {
  return {
    ...state,
    ui: { ...state.ui, isDeactivatingUser: false },
  };
};
